import { CurrentLimits } from 'funds-model';
import _ from 'lodash';
import { ProductType, PRODUCTS } from 'cart-model';

const monthsLeft = () => 11 - new Date().getMonth();

const getLimitForProduct = (productType: ProductType, currentLimits: CurrentLimits, isEntrepreneur = false) => {
  switch (productType) {
    case ProductType.ike:
      return currentLimits.currentLimits.IKE.limit;
    case ProductType.ikze:
      return isEntrepreneur && currentLimits.currentLimits.IKZE.entrepreneurLimit
          ? currentLimits.currentLimits.IKZE.entrepreneurLimit
          : currentLimits.currentLimits.IKZE.limit;
    case ProductType.funds:
    default:
      return Infinity;
  }
};

export const validateLimits = (productType: ProductType,
                        currentLimits: CurrentLimits,
                        initialAmount?: number | null,
                        monthlyAmount?: number | null,
                        isEntrepreneur = false): LimitsValidation => {
  const initialAmountMin = PRODUCTS[productType].minimalAmount;

  const monthlyAmountMin = 50;
  const limit = getLimitForProduct(productType, currentLimits, isEntrepreneur);
  if(_.isNil(initialAmount) || initialAmount < initialAmountMin || _.isNil(monthlyAmount) || monthlyAmount < 0){
    return { isValid: false, initialAmountMin, initialAmountMax: limit, monthlyAmountMax: limit, monthlyAmountMin, showPopovers: false };
  }
  const initialAmountMax = limit;
  const monthlyAmountMax = (limit - initialAmount) / monthsLeft();

  const conditions = [
      initialAmountMin <= initialAmount,
      initialAmount <= limit,
      !monthlyAmount || monthlyAmount <= monthlyAmountMax
  ];

  const isValid = _.every(conditions);
  return { isValid, initialAmountMin, initialAmountMax, monthlyAmountMax, monthlyAmountMin, showPopovers: !isValid };
};

export interface LimitsValidation {
  isValid: boolean;
  showPopovers: boolean;
  initialAmountMin: number;
  initialAmountMax: number;
  monthlyAmountMax: number;
  monthlyAmountMin: number;
}
